/**
 * Utility functions for authentication and user data
 */

/**
 * Get current user data from localStorage
 * @returns {Object|null} User data object or null if not found
 */
export const getCurrentUserData = () => {
    try {
        const userDataString = localStorage.getItem('currentUser');
        if (userDataString) {
            return JSON.parse(userDataString);
        }
    } catch (error) {
        console.error('Error loading user data:', error);
    }
    return null;
};

/**
 * Check if user is authenticated (local check only)
 * @returns {boolean} True if user data exists in localStorage
 */
export const isUserAuthenticated = () => {
    return !!localStorage.getItem('currentUser');
};

/**
 * Get user's display name or fallback
 * @returns {string} User's name or 'User'
 */
export const getUserDisplayName = () => {
    const user = getCurrentUserData();
    return user?.name || 'User';
};

/**
 * Get user's profile picture URL
 * @returns {string|null} Profile picture URL or null
 */
export const getUserProfilePicture = () => {
    const user = getCurrentUserData();
    return user?.picture || null;
};

/**
 * Logout user - calls backend and clears local storage
 */
export const logout = async () => {
    try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
        
        // Call backend logout endpoint
        await fetch(`${apiUrl}/v1/auth/logout`, {
            method: 'POST',
            credentials: 'include'
        });
    } catch (error) {
        console.error('Logout API call failed:', error);
        // Continue with local cleanup even if API call fails
    } finally {
        // Clear all local storage
        localStorage.removeItem('currentUser');
        localStorage.removeItem('hasLoggedIn');
        localStorage.removeItem('selectedFamilyId');
        
        // Redirect to login
        window.location.href = '/login';
    }
};

